import React, { useEffect, useRef } from "react";

export default function TradingSignalBox({ symbol = "OANDA:XAUUSD" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!symbol || !containerRef.current) return;

    const container = containerRef.current;
    container.innerHTML = ""; // clear before creating

    const createWidget = () => {
      try {
        const script = document.createElement("script");
        script.src =
          "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
          interval: "1h",
          width: "100%",
          isTransparent: false,
          height: 500,
          symbol,
          showIntervalTabs: true,
          locale: "en",
          colorTheme: "dark",
        });
        container.appendChild(script);
      } catch (err) {
        console.warn("⚠️ TradingView technical analysis widget error:", err);
      }
    };

    // ensure TradingView base script is ready first
    const ensureTVScript = () => {
      if (window.TradingView) {
        createWidget();
      } else {
        const tvScript = document.createElement("script");
        tvScript.src = "https://s3.tradingview.com/tv.js";
        tvScript.async = true;
        tvScript.onload = () => createWidget();
        tvScript.onerror = () =>
          console.warn("⚠️ TradingView base script failed to load.");
        document.body.appendChild(tvScript);
      }
    };

    // Delay slightly to avoid React re-render collisions
    const timer = setTimeout(() => ensureTVScript(), 300);

    return () => {
      clearTimeout(timer);
      container.innerHTML = "";
    };
  }, [symbol]);

  return (
    <div className="bg-slate-900 rounded-lg shadow p-3 overflow-hidden">
      <h3 className="text-sm font-semibold mb-2">
        📈 Technical Analysis for {symbol}
      </h3>
      <div
        ref={containerRef}
        style={{ minHeight: 500 }}
        className="relative rounded-lg overflow-hidden"
      />
    </div>
  );
}
